/**
 * LoanGapByAmountRangeChart — NOT_CONNECTED
 *
 * Loan gap by range requires LOS integration.
 */
import React from 'react';
import DataSourceNotConnected from './DataSourceNotConnected';
import { NOT_CONNECTED_REGISTRY } from '../../../types/insightsTypes';

const LoanGapByAmountRangeChart: React.FC = () => {
  return (
    <DataSourceNotConnected
      info={NOT_CONNECTED_REGISTRY.los}
      metricName="Loan Gap by Amount Range"
    />
  );
};

export default LoanGapByAmountRangeChart;